<div>
    <h6 class="h6Title">Examen</h6>
    <hr>
</div>

<div fxLayoutAlign="center center" class="fw">
    <div class="examenContainer pdt30">
        <form>
            <div *ngFor="let pregunta of examen; let pregIndex=index">
                <div class="mgb20 border pd10 radius3" fxLayout="column">
                    <h6 class="ft500 ft13 mgb10">Pregunta {{pregIndex+1}}</h6>
                    <div fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="1.5rem" class="mgb10">

                        <input type="text" [(ngModel)]="pregunta.pregunta" [ngModelOptions]="{standalone: true}"
                            class="fw">

                        <span (click)="eliminarPregunta(pregIndex)" class="mgb05 mgr10 grayLink ft500">Eliminar</span>
                    </div>

                    <label> Imagen</label>
                    <input type="file" id="file" (change)="anadirImagen($event,pregIndex)" name="file"
                        autocomplete="off" class="w-30" />


                    <div *ngIf="pregunta.imagen" class="mgt05 mgb10">
                        <img [src]="pregunta.imagen" class="fotoPregunta">
                    </div>

                    <br>
                    <div>
                        <div *ngFor="let opcion of pregunta.opciones; let optIndex=index">
                            <div fxLayout="row" fxLayoutAlign=" center" fxLayoutGap="1rem" class="mgb10">
                                <span class="gray-6">
                                    {{opcion.numero}}.
                                </span>
                                <input type="text" [(ngModel)]="opcion.texto" [ngModelOptions]="{standalone: true}"
                                    class="fw">
                                <input [checked]="checkOpcionCorrecta(pregIndex,optIndex)" type="checkbox"
                                    value={{optIndex}} (change)="checkCorrecta(pregIndex, $event)">
                                <mat-icon class="mgl20 gray-5 cursorPointer ft20"
                                    (click)="eliminarOpcion(pregIndex,optIndex)">
                                    delete_outline
                                </mat-icon>
                            </div>
                        </div>
                        <div fxLayout="row" fxLayoutAlign=" center" class="blueLink mgb05">
                            <span class="mgl20 blue-5 ft13 ft500 cursorPointer" type="button"
                                (click)="anadirOpcion(pregIndex)">Añadir
                                opción</span>
                            <mat-icon class="mgl05 blue-5 linkIcon cursorPointer">add</mat-icon>
                        </div>
                    </div>
                </div>
            </div>

        </form>
        <div class="pd10 border radius3 mgb20">
            <div fxLayout="row" fxLayoutAlign="center center" (click)="anadirPregunta()" class="cursorPointer">
                <span class="ft500 ft14 gray-5 "> Añadir pregunta</span>
                <mat-icon class="mgl10 ft18 linkIcon gray-5">
                    add_circle</mat-icon>
            </div>
        </div>
        <button type="button" class="darkButton mgb40" (click)="guardarExamen()">Guardar examen</button>
    </div>
</div>